import React from 'react';
import { FlatList } from 'react-native';
import { Button } from '@rneui/themed';
import { useChannelQuery } from '@annunciate/query';
import { useTheme, useReactiveThemeProperty } from '../../hooks';
export const SearchRecommendations = ({ onSelected }) => {
    const horizontalGutter = useReactiveThemeProperty('horizontalGutter');
    const { data } = useChannelQuery();
    const theme = useTheme();
    const recommendations = data?.channel?.settings?.search?.recommendations || [];
    if (recommendations.length === 0) {
        return null;
    }
    return (React.createElement(FlatList, { horizontal: true, style: {
            padding: 15,
            paddingHorizontal: horizontalGutter,
            maxWidth: '100%',
            backgroundColor: theme.colors.backgroundPrimary,
            borderBottomColor: theme.colors.borderSecondary,
            borderBottomWidth: 1,
        }, data: recommendations, renderItem: ({ item: text, index }) => (React.createElement(Button, { style: {
                marginRight: 10,
                marginBottom: 5,
            }, key: `${index}-recommendation`, onPress: () => onSelected(text), title: text })), onScrollToIndexFailed: () => { } }));
};
//# sourceMappingURL=SearchRecommendations.js.map